// @ts-nocheck
import { forwardRef } from 'react';
import KpiCardWithTrend from './KpiCardWithTrend';
import type { KpiCardProps } from '../types';

/**
 * KpiCardGradient - KPI card with gradient background
 *
 * A convenience wrapper around KpiCardWithTrend that defaults to gradient variant.
 * Uses the theme's gradient system for beautiful, eye-catching KPI displays.
 */
const KpiCardGradient = forwardRef<HTMLDivElement, KpiCardProps>(
  (props, ref) => {
    return (
      <KpiCardWithTrend
        ref={ref}
        {...props}
        variant="gradient"
      />
    );
  }
);

KpiCardGradient.displayName = 'KpiCardGradient';

export default KpiCardGradient;
